import tableSelect from './table-select.vue'

tableSelect.install = function(Vue) {
  Vue.component(tableSelect.name, tableSelect)
}

export default tableSelect
